import { RawClientConfiguration } from "@common/configuration/adapt-client-configuration";
import { clientConfiguration as prodClientConfiguration } from "@common/configuration/environment.base.prod";
import { clientConfiguration } from "./environment.base";

export const environment = {
    production: true,
    clientConfiguration: Object.assign({}, clientConfiguration, prodClientConfiguration, {
        AltoBaseUri: "https://hq.theadaptway.com",
        AnalyticsProductId: "x55qhp388b",
        ApiBaseUri: "https://hq-api.theadaptway.com",
        GoogleClientId: "799098505879-3p8hsiebaktpehbm2hs568fjs21iqb81.apps.googleusercontent.com",
        SentryDsn: "https://94c020686e854fdb91975bea650c22eb@o96030.ingest.sentry.io/4505033724329984",
        ServiceApiBaseUri: "https://hq-service.theadaptway.com",
        // CalendlyBaseUri: "https://calendly.com/adapt-gabe",
        GoogleTagManagerId: "G-G6TN0Z1Y7C",
        MetaPixelId: "1241249356909364",
    } as Partial<RawClientConfiguration>),
};
